import { FC } from 'react';
import {
  Box,
  Button,
  Center,
  Container,
  Icon,
  Text,
  VStack,
} from '@chakra-ui/react';
import { CheckMarkCircle, Envelope } from '../../assets';
import { getDataTracking } from '../../utils';

export type DonorConfirmThankedProps = {
  donorName: string;
  onAlreadyThanked: () => void;
  onSendThankyou: () => void;
};

export const DonorConfirmThanked: FC<DonorConfirmThankedProps> = (
  props
): JSX.Element => {
  const { donorName, onAlreadyThanked, onSendThankyou } = props;

  return (
    <Container>
      <VStack align="left" spacing="10px">
        <Box>How would you like to thank</Box>
        <Box>
          <Text fontSize="xl" fontWeight="bold">
            {donorName}
          </Text>
        </Box>
        <Box>
          Once you select an option, your donor will be marked as thanked.
        </Box>
        <Box fontStyle="italic">
          If a single donor has made multiple donations, all their past and
          future donations will be marked as thanked.
        </Box>

        <Button
          width="100%"
          height="120px"
          colorScheme="blue"
          variant="secondary"
          onClick={() => onAlreadyThanked()}
          {...getDataTracking('alreadyThankedButton')}
        >
          <Container>
            <Center>
              <Icon as={CheckMarkCircle} boxSize="64px" />
            </Center>
            <Center>I've already thanked</Center>
            <Center>them somewhere else</Center>
          </Container>
        </Button>

        <Button
          width="100%"
          height="120px"
          colorScheme="blue"
          variant="secondary"
          borderWidth="0.1rem"
          onClick={() => onSendThankyou()}
          {...getDataTracking('sendThankButton')}
        >
          <Container>
            <Center>
              <Icon as={Envelope} boxSize="64px" />
            </Center>
            <Center>Send them a thank you</Center>
            <Center>message</Center>
          </Container>
        </Button>
      </VStack>
    </Container>
  );
};
